import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import { Associate } from '@quorum/models/xs-resource';
import { map } from 'rxjs/operators';
import {
  AssociatesEntityActionTypes,
  CreateAssociateOnServer,
  CreateAssociateOnServerSuccess,
  GetAssociateFromServer,
  GetAssociateFromServerSuccess,
  UpdateAssociateOnServer,
  UpdateAssociateOnServerSuccess,
} from './associates.actions';

@Injectable()
export class AssociatesEntityEffects {
  
  getAssociateFromServer = createEffect(() => this.dataPersistence.fetch(AssociatesEntityActionTypes.GetAssociateFromServer, {
    run: (action: GetAssociateFromServer, state: any) => {
      return this.apiService.get<Associate>(`v/1/associates/associates/${action.payload.params.associateId}`, {}).pipe(
        map((associate) => {
          return new GetAssociateFromServerSuccess(associate);
        })
      );
    },
    onError: (action: GetAssociateFromServer, error) => {
      console.error('Error', error);
    },
  }));

  
  updateAssociateOnServer = createEffect(() => this.dataPersistence.fetch(AssociatesEntityActionTypes.UpdateAssociateOnServer, {
    run: (action: UpdateAssociateOnServer, state: any) => {
      console.log(action.payload);
      return this.apiService.put<Associate>(`v/1/associates/associates/${action.payload.id}`, action.payload, {}).pipe(
        map((associate) => {
          return new UpdateAssociateOnServerSuccess(associate);
        })
      );
    },
    onError: (action: UpdateAssociateOnServer, error) => {
      console.error('Error', error);
    },
  }));

  
  createAssociateOnServer = createEffect(() => this.dataPersistence.fetch(AssociatesEntityActionTypes.CreateAssociateOnServer, {
    run: (action: CreateAssociateOnServer, state: any) => {
      return this.apiService.post<Associate>(`v/1/associates/associates`, action.payload, {}).pipe(
        map((associate) => {
          return new CreateAssociateOnServerSuccess(associate);
        })
      );
    },
    onError: (action: CreateAssociateOnServer, error) => {
      console.error('Error', error);
    },
  }));

  constructor(private dataPersistence: DataPersistence<any>, private apiService: ApiService) {}
}
